import React from "react";
import { Text } from "@geist-ui/core";
import { Badge, Button, Flex } from "@radix-ui/themes";
import { PlusIcon } from "@radix-ui/react-icons";
import styles from "./styles.module.scss";
import { ReadOnlyMarkdown } from "@/v2/components/editor/ReadOnlyMarkdown";

interface InstructionsBriefProps {
  brief: string | null;
  briefChanged: boolean;
  setBriefOpen: (value: boolean) => void;
}

export const InstructionsBrief: React.FC<InstructionsBriefProps> = ({
  brief,
  briefChanged,
  setBriefOpen,
}) => {

  return (
    <div className={styles.briefSection}>
      <Flex justify="between" align="center" mb="4">
        <Flex align="center" gap="2">
          <Text style={{ fontSize: "14px", fontWeight: 500 }}>Brief</Text>
          {briefChanged && (
            <Badge
              size="1"
              variant="solid"
              style={{
                backgroundColor: "var(--blue-3)",
                color: "var(--blue-11)",
              }}
            >
              Updates
            </Badge>
          )}
        </Flex>
        <Button variant="ghost" color="gray" onClick={() => setBriefOpen(true)}>
          <Flex align="center" gap="1">
            <PlusIcon />
            Add Brief
          </Flex>
        </Button>
      </Flex>

      <div className={styles.briefContent} onClick={() => setBriefOpen(true)}>
        {brief ? (
          <div className={styles.briefText}>
            <ReadOnlyMarkdown content={brief} />
          </div>
        ) : (
          <div className={styles.emptyBrief}>
            <Text small style={{ color: "var(--gray-9)" }}>
              No brief has been added
            </Text>
          </div>
        )}
      </div>
    </div>
  );
};
